/**
 * 航班计划状态相关工具函数
 */

const STATUS_CONFIG = {
    DRAFT: { text: "草稿", color: "default" },
    SUBMITTED: { text: "已提交", color: "processing" },
    CONFIRMATION_PENDING: { text: "待确认", color: "warning" },
    AIRLINE_CONFIRMED: { text: "航司确认", color: "warning" },
    PUBLISHED: { text: "已发布", color: "success" },
    DEPRECATED: { text: "已废弃", color: "error" },
};

// 获取状态显示文本
export const getStatusText = (status) => STATUS_CONFIG[status]?.text || "未知状态";

// 获取状态颜色
export const getStatusColor = (status) => STATUS_CONFIG[status]?.color || "default";

// 获取回退菜单项
export const getRevertMenuItems = (status, handlers) => {
    const items = [];

    // 根据当前状态，决定显示哪些回退选项
    switch (status) {
        case "SUBMITTED":
            items.push({
                key: "revert_to_draft",
                label: "回退到草稿",
                onClick: handlers.handleRevertToDraft,
            });
            break;
        case "CONFIRMATION_PENDING":
            items.push({
                key: "revert_to_submitted",
                label: "回退到已提交",
                onClick: handlers.handleRevertToSubmitted,
            });
            items.push({
                key: "revert_to_draft",
                label: "回退到草稿",
                onClick: handlers.handleRevertToDraft,
            });
            break;
        case "AIRLINE_CONFIRMED":
            items.push({
                key: "revert_to_confirmation_pending",
                label: "回退到待确认",
                onClick: handlers.handleRevertToConfirmationPending,
            });
            items.push({
                key: "revert_to_submitted",
                label: "回退到已提交",
                onClick: handlers.handleRevertToSubmitted,
            });
            items.push({
                key: "revert_to_draft",
                label: "回退到草稿",
                onClick: handlers.handleRevertToDraft,
            });
            break;
        case "PUBLISHED":
            items.push({
                key: "revert_to_airline_confirmed",
                label: "回退到航司确认",
                onClick: handlers.handleRevertToAirlineConfirmed,
            });
            items.push({
                key: "revert_to_submitted",
                label: "回退到已提交",
                onClick: handlers.handleRevertToSubmitted,
            });
            items.push({
                key: "revert_to_draft",
                label: "回退到草稿",
                onClick: handlers.handleRevertToDraft,
            });
            break;
        default:
            break;
    }

    return items;
};

// 格式化航班时间显示
export const formatFlightTime = (time, timezone = "UTC") => {
    if (!time) return "-";
    // 这里可以根据需要添加时间格式化逻辑
    return time;
};

// 检查状态是否可以执行某个操作
export const canPerformAction = (currentStatus, action) => {
    const actionMap = {
        sendEmail: ["SUBMITTED"],
        confirm: ["SUBMITTED", "CONFIRMATION_PENDING"],
        publish: ["AIRLINE_CONFIRMED"],
        revert: ["SUBMITTED", "CONFIRMATION_PENDING", "AIRLINE_CONFIRMED", "PUBLISHED"], // 回退操作
        deprecate: [], // 废弃操作暂时不放出
    };

    return actionMap[action]?.includes(currentStatus) || false;
};
